import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { PatientService } from './patient.service';
import { Record } from './../models/record.model';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { shareReplay, take, switchMap, filter, withLatestFrom } from 'rxjs/operators';
import { RecordState } from 'src/app/store/record/record.reducer';
import { selectAllRecords } from 'src/app/store/record/record.selectors';
import { AngularFirestore } from '@angular/fire/firestore';
import { deleteRecord } from 'src/app/store/record/record.actions';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { DialogRecordComponent } from 'src/app/shared/components/dialog-record/dialog-record.component';
import { Update } from '@ngrx/entity';

@Injectable({
  providedIn: 'root'
})
export class RecordService {

  records$ = this.store.select(selectAllRecords).pipe(shareReplay(1));

  constructor(
    private store: Store<RecordState>,
    private afs: AngularFirestore,
    private patientService: PatientService,
    private authenticationService: AuthenticationService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar
  ) { }

  openRecordDialog(record: Record, key: string) {
    this.dialog.open(DialogRecordComponent, {
      closeOnNavigation: true,
      restoreFocus: false,
      data: {
        record,
        key
      },
    }).afterClosed().pipe(
      filter(recordChanges => !!recordChanges)
    ).subscribe(changes => {
      console.warn(changes);
      this.updateRecord({
        id: record.id,
        changes
      });
    });
  }

  addRecord() {
    this.patientService.patientId$.pipe(
      filter(patientId => !!patientId),
      withLatestFrom(this.authenticationService.user$),
      take(1),
      switchMap(([patientId, user]) => this.afs.collection('records').add({
        anamnesis: null,
        investigations: null,
        treatment: null,
        patientId,
        createdAt: Date.now(),
        createdBy: {
          userId: user.uid,
          userName: user.displayName
        }
      }))
    ).subscribe(
      docRef => {
        console.warn('record created, ', docRef.id);
      },
      error => {
        console.warn('error creating record:', error);
      }
    );
  }

  updateRecord(update: Update<Record>) {
    this.afs.collection('records').doc(update.id as string).update(update.changes)
      .then(() => {
        console.warn('Record updated');
      })
      .catch(error => {
        this.snackBar.open(`Error updating record: ${error}`, 'Dismiss');
      });
  }


  deleteRecord(id: string) {
    this.afs.collection('records').doc(id).delete()
      .then(() => {
        this.store.dispatch(deleteRecord({ id }));
      })
      .catch(error => {
        this.snackBar.open(`Error deleting record: ${error}`, 'Dismiss');
      });
  }

}
